import { createSelector } from 'reselect'

export const getFormResult = createSelector(
  state => state && state.common && state.common.form && state.common.form.result
    ? state.common.form.result : null,
  result => result
)
